module.exports = __webpack_public_path__ + "img/people.38154dea.svg";